module.exports = __webpack_public_path__ + "media/images/wanderweb/header-wanderweb-019889ab7b597ecb51388da7d6316e58.jpg";